import _ from 'lodash';
import React, { PureComponent } from 'react';
import debug from 'debug';

import { getCurrentMediaQueryKey, getMediaQueryBoundaries } from 'common/utils/story-media-query';

import { Props, State } from './types';
import { Context } from './Context';

const log = debug('client:components:ResponsiveProvider');

class ResponsiveProvider extends PureComponent<Props, State> {
	state: State = {
		currentMediaQueryKey: '',
		boundaries: {
			min: 1025,
			max: 1025,
			containerWidth: 1025,
			isWidest: true,
		},
	};

	static getDerivedStateFromProps(props, state) {
		if (!state.currentMediaQueryKey && props.mediaQuery) {
			const nextMediaQueryKey = getCurrentMediaQueryKey({ mediaQuery: props.mediaQuery });
			log(`Set MediaQuery (initial) — %c${nextMediaQueryKey}`, 'font-weight: bold');
			return {
				currentMediaQueryKey: nextMediaQueryKey,
				boundaries: getMediaQueryBoundaries({
					currentMediaQuery: nextMediaQueryKey,
					mediaQuery: props.mediaQuery,
				}),
			};
		}

		return null;
	}

	componentDidMount() {
		this.setPlatformAttr();
		window.addEventListener('resize', _.debounce(this.onWindowResize, 300));
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onWindowResize);
	}

	setPlatformAttr() {
		document.body.setAttribute('data-platform', this.state.currentMediaQueryKey);
	}

	onWindowResize = () => {
		const { currentMediaQueryKey } = this.state;
		const nextMediaQueryKey = getCurrentMediaQueryKey({ mediaQuery: this.props.mediaQuery });

		if (nextMediaQueryKey !== currentMediaQueryKey) {
			log(`Set MediaQuery (update) — %c${nextMediaQueryKey}`, 'font-weight: bold');
			this.setState(
				{
					currentMediaQueryKey: nextMediaQueryKey,
					boundaries: getMediaQueryBoundaries({
						currentMediaQuery: nextMediaQueryKey,
						mediaQuery: this.props.mediaQuery,
					}),
				},
				() => {
					this.setPlatformAttr();
				}
			);
		}
	};

	render() {
		const { Provider } = Context;
		const { boundaries, currentMediaQueryKey: currentMediaQuery } = this.state;

		return (
			<Provider value={{ currentMediaQuery, boundaries, mediaQuery: this.props.mediaQuery }}>
				{this.props.children}
			</Provider>
		);
	}
}

export default ResponsiveProvider;
